export enum OperationalUnitStatus {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}
